import React from 'react';
import { Field } from 'redux-form';
import { Extra } from './Extra';
import { GuestSelector, ToggleGuestExtra } from './controls';
import { generateGuestOptions } from './utils';

export const Extras = ({
  extras,
  selectedGuests,
  fieldPrefix = 'extras',
  showPrice = false,
  selectedExtras,
}) =>
  extras.map(({ id, extra, featured, name, image, price, description }) => {
    const extraId = extra?.id || id;

    const fieldSuffix = `id-${extraId}`;
    const fieldName = `${fieldPrefix}.${fieldSuffix}`;
    const guestOptions = generateGuestOptions(selectedGuests, extraId, price);

    return (
      <Extra
        featured={featured}
        name={name}
        image={image}
        price={price}
        description={description}
        showPrice={showPrice}
        key={extraId}
        controls={
          <Field
            component={guestOptions.length > 1 ? GuestSelector : ToggleGuestExtra}
            name={fieldName}
            options={guestOptions}
          />
        }
        isSelected={selectedExtras[fieldSuffix]}
      />
    );
  });
